<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage interchanges</small
        >
      </legend>
      <div></div>
      <div>
        <div class="interchangesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading trucks...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemInterchanges"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit interchange!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewInterchange(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit interchange
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Loading date",
          field: "loading_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        },
        {
          label: "Delivery",
          field: "delivery",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter delivery",
          },
        },
        {
          label: "Bond",
          field: "bond",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter Bond",
          },
        },
        {
          label: "Interchange",
          field: "interchange",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter interchange",
          },
        },
        {
          label: "Container number",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter Container number",
          },
        },
        {
          label: "Consignee",
          field: "consignee",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter Consignee",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadInterchanges();
  },
  computed: {
    ...mapGetters(["systemInterchanges"]),
  },
  methods: {
    ...mapActions(["loadInterchanges", "viewInterchange"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/interchanges/manageinterchanges.vue